export class AccountOperationStatisticMessage {
    // тип аккаунт операции
    public OperationType: number;

    // агрегированное за период значение по акк. операции
    public Amount: number;
}
